export const DATA_COUNT = 'data-count';
export const DATA_RATING = 'data-rating';
//# sourceMappingURL=data-attributes.js.map